module.exports = __webpack_public_path__ + "img/add-icon.6f783493.svg";